import { render, staticRenderFns } from "./FRM_Moneda.vue?vue&type=template&id=40baa1ea&"
import script from "./FRM_Moneda.vue?vue&type=script&lang=js&"
export * from "./FRM_Moneda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports